export const UI_SETTINGS_CONSTANTS = {
  FETCH_UI_SETTINGS_REQUEST: 'FETCH_UI_SETTINGS_REQUEST',
  FETCH_UI_SETTINGS_SUCCESS: 'FETCH_UI_SETTINGS_SUCCESS',
  FETCH_UI_SETTINGS_FAIL: 'FETCH_UI_SETTINGS_FAIL',

  UPDATE_UI_SETTINGS_REQUEST: 'UPDATE_UI_SETTINGS_REQUEST',
  UPDATE_UI_SETTINGS_SUCCESS: 'UPDATE_UI_SETTINGS_SUCCESS',
  UPDATE_UI_SETTINGS_FAIL: 'UPDATE_UI_SETTINGS_FAIL',

  FETCH_TAGGED_COMPANIES_REQUEST: 'FETCH_TAGGED_COMPANIES_REQUEST',
  FETCH_TAGGED_COMPANIES_SUCCESS: 'FETCH_TAGGED_COMPANIES_SUCCESS',
  FETCH_TAGGED_COMPANIES_FAIL: 'FETCH_TAGGED_COMPANIES_FAIL',

  RESET_UI_SETTINGS: 'RESET_UI_SETTINGS'
}
